<template>
  <md-card v-if="userInfo" class="provider-card" :class="[{ 'blur-content': showBlured, 'extended-card': extendedCard }]">
    <div class="profile-overlay" v-if="showBlured">
      <md-button class="md-primary md-raised md-theme-blue" @click.prevent.native="onSignUp()">{{$t("SIGN UP TO VIEW PROFILE")}}</md-button>
    </div>
      <md-card-area class="profile-link">
        <md-card-header>
          <a :id="index ? 'va-profile-a-' + index : undefined" :href="providerUrl" class="profile-anchor" @click="onClick">
            <md-card-header-text style="cursor:pointer" @click="onClick">
                <vdl-basic-user-info
                  :limitTextOneLine="true"
                  :name="userInfo.title"
                  :provider="userInfo"
                  :picture="userInfo.thumbPath"
                  :membershipType="userInfo.membershipTypeId"
                  :extendedCard="extendedCard"
                  :index="index"
                  :section="section"
                  :clickable="false"
                  @change:rating-stars="$emit('change:rating-stars', $event)"
                  @click="$emit('click:user-info', $event)">
                </vdl-basic-user-info>
                <slot name="card-content">
                  <div class="number-row"  :class="[{'description-extended': extendedCard }]">
                    <div class="number-container">
                      <div class="flex-container-extended" v-if="extendedCard">
                        <div class="flex-inner-container">
                          <div class="description-container">
                            <p class="description-text" >{{displayableDescription}}</p>
                          </div>
                          <div class="stats-container">
                            <span v-if="providerRating && provider.stats.reviews_count">
                              <vdl-basic-rating-stars class="inline-flex" :rate="providerRating"  @change="$emit('change:rating-stars', $event)"></vdl-basic-rating-stars>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="!extendedCard" class="not-extended-number">
                        <span>Last active</span>
                        <span>{{ lastActiveText || 'Now' }}</span>
                      </div>
                    </div>
                    <div class="number-container" v-if="false">
                      <span>{{(provider.stats.favorited_count || 0)}}</span>
                      <span>{{$t("clients favorited this voice actor")}}</span>
                    </div>
                    <div class="number-container" v-if="false">
                      <span>{{(provider.stats.messages_response_rate || 0)}}</span>
                      <span>messages replied</span>
                    </div>
                    <div class="number-container instant-quote" v-if="bookingQuote">
                      <span></span>
                      <span>Starting from {{bookingQuote}}</span>
                    </div>
                  </div>
                </slot>
            </md-card-header-text>
          </a>
          <md-card-media md-big v-if="audioInfo && audioInfo.url">
            <tdl-audio-player
              :ref="audioInfo.ref"
              :name="audioInfo.name"
              :url="audioInfo.url"
              :providerUrl="providerUrl"
              @audio-listened="onAudioListened"
              @title-click="onClick"
              :before-play="beforeSamplePlay"
              :background-theme="true" ></tdl-audio-player>
          </md-card-media>
        </md-card-header>
        <!--
        <div v-if="underMobileWidth && extendedCard" class="mobile-description-container">
          <p class="description-text" >{{displayableDescription}}</p>
        </div>
        -->
      </md-card-area>
      <md-card-actions class="profile-link" v-if="showActionsSlots">
        <div class="provider-card-contact-div">
          <slot></slot>
        </div>
      </md-card-actions>
  </md-card>
</template>

<script src="./vdlBasicProviderCard.mjs"></script>
<style src="./vdlBasicProviderCard.scss" lang="scss" scoped></style>